import React, { useRef, useEffect } from 'react'
import styles from './ConversationWindow.module.scss'
import MessageList from '../MessageList/MessageList.tsx'
import { Message } from '../../../../../utils/conversationStorage.ts'
import type { DesktopSuggestion } from '../../dashboardActionsConfig.tsx'

interface ConversationWindowProps {
  messages: Message[]
  onClose: () => void
  isLoading?: boolean
  matchedSuggestion?: DesktopSuggestion | null
  onSuggestionAction?: () => void
  onRequestGuide?: () => void
  allSuggestions?: DesktopSuggestion[]
  hasReachedLimit?: boolean
  remainingMessages?: number
  limit?: number
  userData?: any
  pendingImagePreview?: string | null
  isLatestMessageGuardarPost?: boolean
}

const ConversationWindow: React.FC<ConversationWindowProps> = ({
  messages,
  onClose,
  isLoading = false,
  matchedSuggestion,
  onSuggestionAction,
  onRequestGuide,
  allSuggestions = [],
  hasReachedLimit = false,
  remainingMessages = 0,
  limit = 0,
  userData,
  pendingImagePreview = null,
  isLatestMessageGuardarPost = false
}) => {
  const messagesEndRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' })
  }, [messages])

  return (
    <div className={styles.messagesContainer}>
      <MessageList
        messages={messages}
        isLoading={isLoading}
        matchedSuggestion={matchedSuggestion}
        onSuggestionAction={onSuggestionAction}
        onRequestGuide={onRequestGuide}
        allSuggestions={allSuggestions}
        hasReachedLimit={hasReachedLimit}
        remainingMessages={remainingMessages}
        limit={limit}
        userData={userData}
        pendingImagePreview={pendingImagePreview}
        isLatestMessageGuardarPost={isLatestMessageGuardarPost}
      />
      <div ref={messagesEndRef} />
    </div>
  )
}

export default ConversationWindow
